






























































import Vue from 'vue';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import GenericModal from '@/componentsReusable/genericModal.vue';
import HttpMixin from '@/mixins/HttpMixin';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import {EmailHistoryAttachment} from "@/components/communications/history/EmailHistoryModels";

export default Vue.component('email-history-details', {
  props: {
    history: { type: Object }
  },
  mixins: [HttpMixin],
  components: {
    BallPulseLoader,
    GenericModal,
    VueSimpleSpinner
  },
  data() {
    return {
      addingNew: false,
      showConfirmationModal: false,
      // Copy for modification
      theHistory: { ...this.history }
    };
  },
  computed: {
    canDelete(): boolean {
      return this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]) && this.history && this.history.id;
    },
    fromValue(): string {
      const name = this.theHistory.fromName ? this.theHistory.fromName : 'na';
      return `${name} <${this.theHistory.fromEmail}>`;
    },
    toValue(): string {
      const name = this.theHistory.toName ? this.theHistory.toName : 'na';
      return `${name} <${this.theHistory.toEmail}>`;
    }
  },
  methods: {
    getUniqueId(fieldName: string): string {
      if (this.history) {
        return 'email-history-details-' + this.history.id + '-' + fieldName;
      }
      return '';
    },
    async deleteHistory(bypassDeleteConfirmation: boolean) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        return;
      }
      const success = await (this as any).httpDelete(`/email-history/${this.history.id}`, 'Failed to delete Email History Details');
      if (success) {
        this.$emit('saved');
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Deleted',
          text: `Email History successfully deleted.`,
        });
      }
    },
    async deleteConfirmed() {
      this.showConfirmationModal = false;
      await this.deleteHistory(true);
    },
    async save() {
      let success = false;
      if (this.history.id) {
        success = await this.httpPut(`/email-history/${this.history.id}`, 'Failed to create Email History record.', this.theHistory);
      } else {
        success = await this.httpPost('/email-history', 'Failed to create Email History record.', this.theHistory);
      }
      if (success) {
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Saved',
          text: `Email History saved.`,
        });
        this.$emit('saved');
      }
    },
    async fetchAttachment(attachment: EmailHistoryAttachment) {
      const data = await (this as any).httpGet(`/s3/signed-url/get?s3key=${attachment.s3Key}`, `Error getting email attachment.`);
      if (data) {
        window.open(data, '_blank');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/communications/history/EmailHistoryDetails.vue